export default __webpack_public_path__ + "static/media/cryptocurrency.b0d0a3b5.png";